// Formatted as MM/DD/YYYY — the pre-formatted seed `MaskedInputField` needs: it re-formats on
// mount but only fires its change event when the calibrated value differs from what's already
// there, so a pre-formatted seed never dirties the form, while a raw one would
// (contracts/client-profile.md, "Seeding the form takes two conversions").
//
// `dateOfBirth` is a date-only value stored at UTC midnight, serialised as an ISO string ending in
// `Z`. Reading the `YYYY-MM-DD` straight off that string — rather than through a `Date`'s local
// getters — is what keeps a therapist west of Greenwich from seeing it roll back a day (the same
// reasoning as `usage-history-to-display.ts`'s `formatPeriodLabel`).
export function formatDateOfBirth(dateOfBirth: string | null): string {
    if (!dateOfBirth) return '';

    const [year, month, day] = dateOfBirth.slice(0, 10).split('-');

    return `${month}/${day}/${year}`;
}
